import React, { useState, useEffect } from "react";
import AccountSidebar from "../../components/Account/SIdebar";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import { getUserOrders, cancelOrderRequest } from "../../apiCalls/order";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import DataTable from "react-data-table-component";
import { ImageUrl } from "../../requestMethods";
import { toast } from "react-toastify";

const MyOrders = () => {
  const dispatch = useDispatch();
  const orders = useSelector((state) => state.orders.orders.data);
  const user = useSelector((state) => state.user.currentUser);
  const [show, setShow] = useState(false);
  const [activeId, setActiveId] = useState("");

  console.log(orders, "orders");

  const columns = [
    {
      name: "Order ID",
      selector: (row) => row.orderId,
    },
    {
      name: "Date/Time",
      selector: (row) => moment(row?.createdAt).format("LL"),
    },

    {
      name: "Items",
      selector: (row) => row?.productItems?.length,
    },
    {
      name: "Amount",
      selector: (row) => row.payAmount,
    },
    {
      name: "Status",
      selector: (row) => row.status,
    },
  ];

  useEffect(() => {
    getUserOrders(dispatch, user?._id);
  }, [dispatch]);

  const cancelRequest = async (id) => {
    try {
      let { data: res } = await cancelOrderRequest(id, {
        status: "cancelledbyUser",
      });
      console.log(res, "res");
      if (res.success === true) {
        toast.error(`😢 ${res.message}`);
      }
    } catch (err) {
      toast.err(`🦄 Server Error`);
    }
  };

  const showModal = (id) => {
    console.log("show order details");
    setActiveId(id);
    setShow(true);
  };

  const ExpandedComponent = ({ data }) => {
    console.log(data, "data");
    return (
      <div className="order-details">
        {data.productItems.map((prod, index) => {
          return (
            <div className="prod-items" key={index}>
              <div className="prod-left">
                <div className="order-prod-img">
                  <img
                    src={`${ImageUrl}` + prod?.mainImg[0]?.filename}
                    alt=""
                    className="img-fluid"
                  />
                </div>
                <div className="order-prod-det">
                  <h4 className="order-prod-name">{prod.productName} </h4>
                  {prod.color ? (
                    <p className="order-prod-color">
                      Color:{" "}
                      <span style={{ backgroundColor: prod.color }}></span>
                    </p>
                  ) : (
                    ""
                  )}

                  {prod.size ? (
                    <p className="order-prod-size">
                      Size: <span>{prod.size}</span>
                    </p>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="prod-right">
                <div className="order-prod-quantity">
                  <h4>
                    <span>X</span>
                    {prod.quantity}
                  </h4>
                </div>
                <div className="order-prod-amount">
                  <h4>
                    <span>₹</span>
                    {prod.price}.00
                  </h4>
                </div>
              </div>
            </div>
          );
        })}
        <div className="order-infos">
          <ul>
            <li>
              <p className="success-title">Order Date :</p>
              <p className="text">
                {" "}
                {moment(data?.createdAt).format("LL")} at{" "}
                {moment(data?.createdAt).format("LT")}
              </p>
            </li>
            <li>
              <p className="success-title">Order ID :</p>
              <p className="text">{data.orderId}</p>
            </li>
            <li>
              <p className="success-title">Status :</p>
              <p className="text">{data.status}</p>
            </li>
            <li>
              <p className="success-title">Payment Method :</p>
              <p className="text">{data.paymentMethod}</p>
            </li>
            <li>
              <p className="success-title">Amount :</p>
              <p className="text">₹ {data.payAmount}.00</p>
            </li>
            <li>
              <p className="success-title">Shipping Amount :</p>
              <p className="text">₹ {data.shippingAmount}.00</p>
            </li>
            <li className="total-order">
              <p className="success-title">Total :</p>
              <p className="text">₹ {data.payAmount}.00</p>
            </li>

            {data.status === "cancelledBySeller" ||
            data.status === "delivered" ||
            data.status === "retrun" ||
            data.status === "cancelledbyUser" ? (
              ""
            ) : (
              <li className="can-btn mt-1">
                <p></p>
                <button
                  className="btn danger-btn"
                  onClick={() => cancelRequest(data._id)}
                >
                  Cancel Request
                </button>
              </li>
            )}
          </ul>
        </div>
      </div>
    );
  };

  return (
    <>
      <Breadcrumb
        activeName={"Order History"}
        middleName={"My-Account"}
        middleUrl={"/my-account"}
      />
      <section className="account-section">
        <div className="container">
          <div className="row">
            <div className="col-full">
              <div className="account-data">
                <AccountSidebar />
                <div className="single-account-dashboard-data">
                  <div className="single-account-wrapper">
                    <h2 className="tabcontent-title">My Orders</h2>
                    <DataTable
                      columns={columns}
                      data={orders}
                      expandableRows
                      expandableRowsComponent={ExpandedComponent}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MyOrders;
